import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import { NavigationDataProvider } from '../../modules/NavigationProvider';
import Footer from './Footer';
import Header from './Header';

const Layout = () => (
  <NavigationDataProvider>
    <Container
      fluid="md"
      className="d-flex flex-column svh-100 pb-xs-2 py-4 py-md-5 gap-3"
    >
      <Header />
      <Outlet />
      <Footer />
    </Container>
  </NavigationDataProvider>
);

export default Layout;
